var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: [_vm.isFullScreen() ? "stt-Popup" : "stt-Slide-Popup"] },
    [
      _c(
        "div",
        { staticClass: "header-stt-Popup" },
        [
          _c("span", [_vm._v("参考模板")]),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.handleClose } },
            [
              _c("i", {
                staticClass: "el-icon-close",
                staticStyle: { "font-size": "20px", color: "#fff" },
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content-stt" },
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "content-stt-item",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.selectItem(item.content)
                },
              },
            },
            [
              _c("div", {
                staticClass: "content-stt-item-detail",
                domProps: { innerHTML: _vm._s(item.content) },
              }),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }